"use strict";

var _regeneratorRuntime = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var bus_sparql_serialize_1 = require("@comunica/bus-sparql-serialize");
/**
 * A comunica RDF SPARQL Serialize Actor.
 *
 * It serializes quad streams (for example resulting from a CONSTRUCT query)
 * to an RDF syntax.
 */


var ActorSparqlSerializeRdf =
/*#__PURE__*/
function (_bus_sparql_serialize) {
  _inherits(ActorSparqlSerializeRdf, _bus_sparql_serialize);

  function ActorSparqlSerializeRdf(args) {
    _classCallCheck(this, ActorSparqlSerializeRdf);

    return _possibleConstructorReturn(this, _getPrototypeOf(ActorSparqlSerializeRdf).call(this, args));
  }

  _createClass(ActorSparqlSerializeRdf, [{
    key: "testHandle",
    value: function () {
      var _testHandle = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(action, mediaType, context) {
        var mediaTypes;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(action.type !== 'quads')) {
                  _context.next = 2;
                  break;
                }

                throw new Error('Actor ' + this.name + ' can only handle quad streams');

              case 2:
                _context.next = 4;
                return this.mediatorMediaTypeCombiner.mediate({
                  context: context,
                  mediaTypes: true
                });

              case 4:
                mediaTypes = _context.sent.mediaTypes;

                if (mediaType in mediaTypes) {
                  _context.next = 7;
                  break;
                }

                throw new Error('Actor ' + this.name + ' can not handle media type ' + mediaType + '. All available types: ' + Object.keys(mediaTypes));

              case 7:
                return _context.abrupt("return", true);

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function testHandle(_x, _x2, _x3) {
        return _testHandle.apply(this, arguments);
      }

      return testHandle;
    }()
  }, {
    key: "runHandle",
    value: function () {
      var _runHandle = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(action, mediaType, context) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.mediatorRdfSerialize.mediate({
                  context: context,
                  handle: {
                    quads: action.quadStream
                  },
                  handleMediaType: mediaType
                });

              case 2:
                return _context2.abrupt("return", _context2.sent.handle);

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function runHandle(_x4, _x5, _x6) {
        return _runHandle.apply(this, arguments);
      }

      return runHandle;
    }()
  }, {
    key: "testMediaType",
    value: function () {
      var _testMediaType = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3(context) {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt("return", true);

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function testMediaType(_x7) {
        return _testMediaType.apply(this, arguments);
      }

      return testMediaType;
    }()
  }, {
    key: "getMediaTypes",
    value: function () {
      var _getMediaTypes = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4(context) {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.mediatorMediaTypeCombiner.mediate({
                  context: context,
                  mediaTypes: true
                });

              case 2:
                return _context4.abrupt("return", _context4.sent.mediaTypes);

              case 3:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function getMediaTypes(_x8) {
        return _getMediaTypes.apply(this, arguments);
      }

      return getMediaTypes;
    }()
  }]);

  return ActorSparqlSerializeRdf;
}(bus_sparql_serialize_1.ActorSparqlSerialize);

exports.ActorSparqlSerializeRdf = ActorSparqlSerializeRdf;